// Set of actions to get availability market when user try to invest in one specific product
// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

function getExchangeAvailabilitySuccess(response) {
    return {
        type: actionTypes.BROKER_EXCHANGE_AVAILABILITY_SUCCESS,
        payload: {
            currentDate: response.currentDate,
            isAvailableToday: response.isAvailableToday || false
        }
    }
}

function getExchangeAvailabilityError() {
    return {
        type: actionTypes.BROKER_EXCHANGE_AVAILABILITY_ERROR,
        payload: {
            currentDate: false,
            isAvailableToday: true
        }
    }
}

function filterResult(result, exchangeId) {
    if (exchangeId) {
        return result.find(exchange => exchange.exchangeId == exchangeId);
    }
    else {
        return {};
    }
}

const getExchangeAvailability = (exchangeId) => (dispatch) => {
    const requestData = {
        query: {
            exchangeId
        }
    }

    return APIGet(dispatch, apiURLBuilder.getURL('brokerExchangesAvailability'), requestData)
        .then((response) => {
            dispatch(getExchangeAvailabilitySuccess(filterResult(response, requestData.query.exchangeId)));
        })
        .catch(() => {
            dispatch(getExchangeAvailabilityError());
        }
    );
}

function getSelectedMarketsExchangeAvailabilitySuccess(marketsData) {
    return {
        type: actionTypes.BROKER_SELECTED_MARKETS_EXCHANGE_AVAILABILITY_SUCCESS,
        payload: {
            marketsData
        }
    }
}

function getSelectedMarketsExchangeAvailabilityError(marketCodeList) {
    return {
        type: actionTypes.BROKER_SELECTED_MARKETS_EXCHANGE_AVAILABILITY_ERROR,
        payload: {
            marketCodeList,
            currentDate: false,
            isAvailableToday: true
        }
    }
}

function filterSelectedMarkets(result, marketCodeList) {
    let mappedResult = result.map(market => ({
        isoCode: market.isoCode,
        currentDate: market.currentDate,
        isAvailableToday: market.isAvailableToday
    }));
    if(marketCodeList) {
        mappedResult = mappedResult.filter(market => {
            return marketCodeList.find(marketCode => market.isoCode.trim() === marketCode.trim());
        });
    }

    return mappedResult;
}

const getSelectedMarketsExchangeAvailability = (marketCodeList) => (dispatch) => {
    return APIGet(dispatch, apiURLBuilder.getURL('brokerExchangesAvailability')).then(
        (response) => {
            dispatch(getSelectedMarketsExchangeAvailabilitySuccess(filterSelectedMarkets(response, marketCodeList)));
        },
        () => {
            dispatch(getSelectedMarketsExchangeAvailabilityError(marketCodeList));
        }
    );
}

module.exports = {
    getExchangeAvailability,
    getSelectedMarketsExchangeAvailability
}